<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0 ma-0">
      <v-tabs
        v-model="tab"
        centered
        grow
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-if="mostrarVista(14) || mostrarVista(7) || mostrarVista(15)"
          href="#programacion_pago_orden"
          @click="actualizarItems('programacion_pago_orden')"
        >
          Ordenes de Programación de Pago
        </v-tab>

        <v-tab
        v-if="mostrarVista(45)"
          href="#recepcion_validacion_facturas"
          @click="actualizarItems('recepcion_validacion_facturas')"
        >
          Validación de Facturas <br> y Evidencias - OPP
        </v-tab>

        <v-tab
          v-if="mostrarVista(46)"
          href="#facturas"
          @click="actualizarItems('facturas')"
        >
          Facturas
        </v-tab>

        <v-tab
          v-if="mostrarVista(7) || mostrarVista(15)"
          href="#catalogos"
          @click="actualizarItems('catalogos')"
        >
          Catálogos
        </v-tab>

        <!--
        <v-tab
          href="#empleado_tarjetas"
          @click="actualizarItems('empleado_tarjetas')"
        >
          Tarjetas Bancarias - Pago REGA'S
        </v-tab>
        -->
      </v-tabs>
          
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-if="mostrarVista(7) || mostrarVista(15)"
          value="catalogos"
        >
          <catalogos
            ref="catalogos"
          >
          </catalogos>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(45)"
          value="recepcion_validacion_facturas"
        >
          <recepcion-validacion-facturas
            ref="recepcion_validacion_facturas"
          >
          </recepcion-validacion-facturas>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(14) || mostrarVista(7) || mostrarVista(15)"
          value="programacion_pago_orden"
        >
          <programacion-pago-orden
            ref="programacion_pago_orden"
          >
          </programacion-pago-orden>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(46)"
          value="facturas"
        >
          <facturas
            ref="facturas"
          >
          </facturas>
        </v-tab-item>
      
        <!--
        <v-tab-item
          value="empleado_tarjetas"
        >
          <empleado-tarjetas
            ref="empleado_tarjetas"
          >
          </empleado-tarjetas>
        </v-tab-item>
        -->

      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import Catalogos from './Pagos/Catalogos.vue'
//import EmpleadoTarjetas from './Pagos/EmpleadoTarjetas.vue'
import ProgramacionPagoOrden from './Pagos/ProgramacionPagoOrden.vue'
import RecepcionValidacionFacturas from './Pagos/RecepcionValidacionFacturas.vue'
import Facturas from './Pagos/Facturas.vue'

export default {
  computed: {
    ...mapState(['ids_vistas'])
  },
  components:{
    Catalogos,
    //EmpleadoTarjetas,
    ProgramacionPagoOrden,
    RecepcionValidacionFacturas,
    Facturas
  },
  data: () => ({
    tab: null
  }),
  methods: {
    mostrarVista(id_vista){
      if(this.ids_vistas == null || this.ids_vistas.length == 0) return false;
      return (this.ids_vistas.indexOf(id_vista) >= 0);
    },
    getItems(){
      this.actualizarItems(this.tab);
    },
    actualizarItems(refName) {
      if (this.$refs[refName] && this.$refs[refName].getItems) {
        this.$refs[refName].getItems();
      } else {
        console.warn(`No se encontró la referencia: ${refName}`);
      }
    }
  }
}
</script>